import jobTitleForUrl from './jobTitleForUrl';

interface Props {
  title: string;
  objectID: string;
}

const removeJobIdFromUrl = ({ title, objectID }: Props) => {
  const url = new URL(window.location.toString());
  const jobTitle = jobTitleForUrl(title);
  url.pathname = url.pathname.replaceAll(`/${objectID}`, ``);
  url.pathname = url.pathname.replaceAll(`-${jobTitle}`, ``);
  window.history.pushState({}, ``, url);
};

export default removeJobIdFromUrl;
